import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/_layout/admin')({
  component: RouteComponent,
  beforeLoad: async ({ context: { api } }) => {
    const {
      user: { sessionClaims },
    } = await api.admin.$get().then((res) => res.json());
    if (!sessionClaims?.meta?.isSuperUser) {
      console.log('Not a super user, redirecting to home');
      throw redirect({ to: '/pulls' });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
